import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { string, any, object, bool } from 'prop-types';
import { LazyCollection } from '@quintype/components';
import queryString from 'query-string';
import ClockIcon from '../../../atoms/icons/clock-icon';
import MostReadFourStoryPiano from '../../../atoms/most-read-piano/most-read-four-story';
import storyElementWithCustomTemplates from '../../../story/story-elements/index';

import { getDuration, getStoryDate, syndicatedSource } from '../../../../helpers/utils';
import { getCollectionTemplate } from '../../../../helpers/get-collection-template';

import get from 'lodash/get';
import './single-video-with-playlists.m.css';
import Authors from '../../../story/authors/authors';
import { ClockOutlineIcon } from '../../../atoms/material-icons';
import PublishedInfo from '../../../story/published-info/published-info';
import Share from '../../../story/share/share';
import { trackUserInteraction } from '../../../../helpers/datalayer-utils';

const storyShareClickHandler = (storyContentId, storyUrl) => (event) =>
  global.app.registerStoryShare(
    storyContentId,
    event.currentTarget.getAttribute('data-social-media-type'),
    storyUrl
  );

function addLinkToCopy() {
  var bodyElement = document.getElementsByTagName('body')[0];
  var selection = window.getSelection();
  var pagelink =
    "<br /><br /> Read more at: <a href='" +
    document.location.href +
    "'>" +
    document.location.href +
    '</a><br />Copyright &copy; NDTV Profit';
  var copytext = selection.toString().substring(0, 400) + pagelink;
  var newdiv = document.createElement('div');
  newdiv.style.position = 'absolute';
  newdiv.style.left = '-99999px';
  bodyElement.appendChild(newdiv);
  newdiv.innerHTML = copytext;
  selection.selectAllChildren(newdiv);
  window.setTimeout(function () {
    bodyElement.removeChild(newdiv);
  }, 0);
}

const SingleVideoStoryWithPlayLists = ({
  story,
  singleVideoPageCollection,
  showSingleVidibleVideo,
  bookmark,
  publisherUrl,
  ...props
}) => {
  const duration = story.cards[0]['story-elements'][0].metadata['duration-millis'] || false;

  useEffect(() => {
    // TODO: Reset function when unmounting
    document.oncopy = addLinkToCopy;
    const queryObject = queryString.parse(window.location.search);

    if (queryObject.utm_source === 'wru') {
      const datalayerFields = {
        category: 'article page',
        action: 'Recommended for you',
        label: get(story, ['story', 'headline'], ''),
        event: 'event articlepage',
        cd22: 'link',
        cd23: 'bottom more on this topic',
        cd24: 'NA', // element id
        cd26: syndicatedSource(get(story, 'story', null)),
        cd31: get(story, ['story', 'story-template'], 'text'),
        cd35: 'wru',
        cd34: 'NA', // source of the user
      };
      trackUserInteraction(datalayerFields);
    }
    if (window.history.length === 1) {
      const _datalayerFields = {
        event: 'event Back button clicked',
        label: 'back button',
        action: 'click',
      };
      (function (window, location) {
        history.replaceState(null, document.title, location.pathname + '#!/homepage');
        history.pushState(null, document.title, location.pathname);

        window.addEventListener(
          'popstate',
          function () {
            if (location.hash === '#!/homepage') {
              history.replaceState(null, document.title, location.pathname);
              trackUserInteraction(_datalayerFields);
              setTimeout(function () {
                location.replace('https://www.ndtvprofit.com/');
              }, 0);
            }
          },
          false
        );
      })(window, location);
    }
  }, []);

  const datalayerFields = {
    category: 'article page',
    action: 'NA',
    label: story.headline,
    event: 'event articlepage',
    cd22: 'link',
    cd23: 'NA', // element location
    cd24: 'NA', // element id
    cd26: syndicatedSource(story),
    cd31: story['story-template'] || 'text',
    cd35: 'NA', // recommendation engine
    cd34: 'NA', // source of the user
  };

  return (
    <div className="container" styleName="single-video-container">
      <div className="sidebar" styleName="video-wrapper">
        <div styleName="video">
          <h1 styleName="story-title">{story.headline}</h1>
          <div styleName={'story-content-head'}>
            <div styleName="author-and-published-time">
              <Authors
                storyId={story.id}
                authors={story.authors}
                datalayerFields={datalayerFields}
                alt="BQ"
              />
              <span
                styleName="story-published-date"
                dateTime={new Date(story['first-published-at'])
                  .toISOString()
                  .replace('Z', '+05:30')}
              >
                <ClockOutlineIcon size="18px" color="var(--regent-gray)" />
                <span styleName="story-date">{getStoryDate(story['last-published-at'])} </span>
                <span className="icon-ic_info_outline" styleName="story-date-info-icon"></span>
                <div styleName="popover-story-dates">
                  <PublishedInfo
                    publishedAt={story['first-published-at']}
                    updatedAt={story['last-published-at']}
                  />
                </div>
              </span>
            </div>

            {/* Social share option beside author details */}
            <div styleName="share-floating-expanded">
              <img
                src={props?.googlenews_icon}
                title="Google News"
                height="46vw"
                alt="google-news-follow"
                onClick={() =>
                  window.open(
                    'https://news.google.com/publications/CAAqBwgKMKr0kAsw9JylAw?hl=en-IN&gl=IN&ceid=IN%3Aen',
                    '_blank'
                  )
                }
              />
              <Share
                datalayerFields={datalayerFields}
                title={story.headline}
                url={story.slug}
                summary={story.summary}
                services={['whatsapp', 'twitter', 'facebook', 'telegram']}
                onClick={storyShareClickHandler(
                  story['story-content-id'],
                  `${publisherUrl}/${story.slug}`
                )}
                source="story-content-head"
                expanded={true}
                alignType="horizontal"
                showToggleWhenExpanded={false}
                bookmark={bookmark}
                storyId={story['story-content-id']}
              />
            </div>
          </div>
          {story.cards.map((card) => (
            <div key={card.id}>
              {card['story-elements'].map((element) =>
                storyElementWithCustomTemplates(card, element, story)
              )}
            </div>
          ))}
          {duration && (
            <div styleName="time-stamp">
              <ClockIcon />
              <span>{getDuration(duration || 0)}</span>
            </div>
          )}
        </div>
        <div className="mobile-hidden">
          <MostReadFourStoryPiano />
        </div>
      </div>

      {singleVideoPageCollection ? (
        <LazyCollection
          showSingleVidibleVideo={showSingleVidibleVideo}
          collection={singleVideoPageCollection}
          collectionTemplates={getCollectionTemplate}
          lazyAfter={1}
        />
      ) : null}
    </div>
  );
};

SingleVideoStoryWithPlayLists.propTypes = {
  story: object,
  singleVideoPageCollection: any,
  showSingleVidibleVideo: bool,
  bookmark: bool,
  publisherUrl: string.isRequired,
};

const mapStateToProps = (state) => ({
  publisherUrl: state.qt.config['sketches-host'],
  textSelectionEnabled: state.qt.config.features.story.text_selection.enabled,
  juspayMicroFlow: state.qt.config.features.subscription.juspay_micro,
  amazon_polly: get(state.qt, ['config', 'features', 'amazon_polly', 'enabled'], false),
  bookmark: get(state, ['qt', 'config', 'features', 'bookmark', 'enabled'], false),
  googlenews_icon: get(state, ['qt', 'config', 'publisher', 'cdn-images', 'googlenews'], ''),
});

export default connect(mapStateToProps, {})(SingleVideoStoryWithPlayLists);
